import React, { Component } from "react";
import { Helmet } from "react-helmet";
import moment from "moment";

import Api from "../../../../lib/componentApi";
import getAppErrors from "../../../../lib/appErrors";
import AppErrors from "../../../../components/Common/AppErrors";

export default class PromotionsList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      promotions: [],
      message: "",
      promoCode: "",
      copied: false
    };
    this.pRef = React.createRef();
  }
  componentDidMount() {
    this.getPromotions();
  }
  getPromotions = () => {
    Api.get("/api/user/promotions", {}, (response, errors) => {
      if (errors) {
        if (errors === 503) {
          this.setState(() => {
            throw errors;
          });
        } else {
          console.log(errors);
        }
      } else if (response.code) {
        console.log(response, "promotions-code");
      } else {
        this.setState({ promotions: response });
      }
    });
  };
  handleSubmitPromoCode = () => {
    const { promoCode } = this.state;
    var body = document.body;
    Api.post("/api/use/promo/code", { promoCode }, (response, errors) => {
      if (errors) {
        if (errors === 503) {
          this.setState(() => {
            throw errors;
          });
        } else {
          console.log(errors);
        }
      } else if (response.code) {
        body.classList.add("body-overflow");
        const errorMessage = getAppErrors(response.code);
        this.setState({
          message: (errorMessage && errorMessage.message) || response.message
        });
      } else {
        this.setState({ promoCode: "" }, () => {
          this.getPromotions();
        });
      }
    });
  };
  onClickClose = () => {
    var body = document.body;
    this.setState(
      {
        message: null
      },
      () => {
        body.classList.remove("body-overflow");
      }
    );
  };
  handleChange = event => {
    event.preventDefault();
    this.setState({
      [event.target.id]: event.target.value
    });
  };
  handleCopy = () => {
    const copyTex = this.pRef;
    let self = this;
    try {
      const node = document.createElement("textarea");
      node.innerHTML = copyTex;
      document.body.appendChild(node);
      node.select();
      document.execCommand("copy");
      node.style.display = "none";
      self.setState({
        copied: true
      });
    } catch (error) {
      console.log(error);
    }
  };
  getPromotionsText = promotion => {
    let dateText, bodyText, statusText;
    dateText = moment(promotion.createdAt).format("YYYY-MM-DD");
    const expiryDateDiff = moment(new Date()).diff(
      moment(promotion.expiryAt),
      "minutes"
    );
    statusText = (expiryDateDiff < 0 && "Expired") || "Redeemed";
    switch (promotion.gainType) {
      case "AMOUNT":
        bodyText = `£${parseFloat(promotion.gainAmount).toFixed(2)}`;
        break;
      case "PERCENT":
        bodyText = `%${promotion.gainAmount}`;
        break;
      case "POINTS":
        bodyText = `+${promotion.gainAmount} eCoins.`;
        break;
      case "FREE_DELIVERY":
        bodyText = `Free Delivery`;
        break;
    }
    return { dateText, bodyText, statusText };
  };
  render() {
    const { promoCode, promotions, message, copied } = this.state;
    const { onCloseSection, userCode } = this.props;
    return (
      <div className="promotion-page">
        <Helmet>
          <title>Promotions</title>
          <meta property="og:title" content="Promotions" />
        </Helmet>
        {/* Header */}
        <div className="head-general with-back">
          <a
            href="javascript: void(0)"
            onClick={() => onCloseSection("promotionsSection")}
            className="back"
          >
            <img src="/png/chevron-left.png" />
          </a>
          <h4>Promotions</h4>
          <a href="javascript: void(0)" className="close" />
        </div>
        {/* Header */}

        <React.Fragment>
          <div className="profile-desktop">
            <h4 className="general-title hide-xs">Promotions</h4>
            <div className="row">
              <div className="col-sm-5">
                <div className="white-bg mt-10px padding-box head">
                  <h5>Enter Promo Code</h5>
                  <input
                    type="text"
                    className="form-input"
                    value={promoCode.toUpperCase()}
                    onChange={this.handleChange}
                    id="promoCode"
                  />
                </div>
              </div>
              <div className="col-sm-3">
                <div className="button mt-10px">
                  <button
                    onClick={this.handleSubmitPromoCode}
                    disabled={!promoCode.length}
                    className="btn btn-blue"
                  >
                    Apply
                  </button>
                </div>
              </div>
            </div>
            {/* .row */}
          </div>
          {/* .profile-desktop */}

          <div className="white-bg mt-10px padding-box your-code">
            <p>Share this for 250 referral eCoins</p>
            <h5 className="cursor-pointer" onClick={this.handleCopy}>
              {userCode} <icon className="icon icon-shape" />
            </h5>
            {(copied && (
              <p>
                <strong>Copied !</strong>
              </p>
            )) || (
              <p
                style={{ display: "none" }}
                ref={() => {
                  this.pRef = `https://mylocale.co.uk/invite/${userCode}`;
                }}
                className="cursor-pointer"
                onClick={this.handleCopy}
              >
                {`https://mylocale.co.uk/invite/${userCode}`}{" "}
                <strong>Copy Link</strong>
              </p>
            )}
          </div>
          {message && (
            <AppErrors message={message} onClickClose={this.onClickClose} />
          )}
          {(promotions && promotions.length && (
            <div className="white-bg mt-10px padding-box list">
              <h5>Promotions</h5>
              <ul>
                {promotions.map(promotion => {
                  const {
                    dateText,
                    bodyText,
                    statusText
                  } = this.getPromotionsText(promotion);
                  return (
                    <li
                      key={promotion.id}
                      className="d-flex justify-content-between align-items-center"
                    >
                      <div>
                        <p>{dateText}</p>
                        <p className="bold">{bodyText}</p>
                      </div>
                      <p className="small-label">{statusText}</p>
                    </li>
                  );
                })}
              </ul>
            </div>
          )) || <noscript />}
        </React.Fragment>
      </div>
    );
  }
}
